import API from '@/api/index';
import moment from 'moment';

const vehicle = {
  state: {
    vehicles: [],
    totalVehicle: 0
  },

  mutations: {
    SET_VEHICLES: (state, vehicles) => {
      let items = [];
      vehicles.map(a => {
        if (a.remainExpiryDay) { a['expiryDay'] = moment().add(a.remainExpiryDay, 'days').valueOf() } 
        return 0;
      });
      
      state.vehicles = vehicles;
    },

    SET_TOTAL_VEHICLES: (state, totalVehicle) => {
      state.totalVehicle = totalVehicle;
    }
  },

  actions: {
    getVehicles ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.vehicle
          .getVehicles(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let vehicles = result.data.data;
              commit('SET_VEHICLES', vehicles);
              commit('SET_TOTAL_VEHICLES', result.data.totalRecords);
              resolve(vehicles);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    deleteVehicles ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle
          .deleteVehicles(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    switchDevice ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle
          .switchDevice(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    lockDevice ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle
          .lockDevice(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default vehicle;



// WEBPACK FOOTER //
// ./src/store/modules/vehicle.js